import React, { useEffect, useState } from 'react';
import { chatService } from 'services/chat.service';

const useChatById = (payload = { skip: 0, limit: 5, chatId: '' }) => {
    const [chatMessages, setChatMessages] = useState({});

    const handleApi = async () => {
        try {
            const response = await chatService.getMessages(payload);
            setChatMessages(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, [payload?.chatId]);

    return { chatMessagesData: chatMessages };
}

export default useChatById;